const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["./alpine-swap-lYM3j0MN.js","./utils-oRzKe-6b.js","./accordion-I9q_btvo.js","./module.esm-CWk4R-Yb.js","./define-C8Myl9X3.js","./footer-CjVLgRO4.js","./header-Bgn9bTmJ.js","./modal-ILPGkwVI.js","./noscroll-06hwtYVt.js","./modal-toggle-CuCS-vJA.js","./navigation-DHul_NCp.js","./video-player-CdWLIGVS.js","./preload-helper-DYl5dUZ5.js","./infinite-scroll-Ct8c6qFA.js","./product-info-D6pZBQ78.js","./product-slider-ZyUCnnrm.js","./device-Bin8Gna7.js","./keyboard-BgVhSZbN.js","./keyboard-BwPmHypo.css","./product-zoom-D6m7hYLY.js","./wishlist-DJSYajB3.js","./wishlist-grid-Bc-56yag.js"])))=>i.map(i=>d[i]);
import { t as e } from "./module.esm-CWk4R-Yb.js";
import { isDesktop as t, isMobile as n, isTouch as r, mobileQuery as i } from "./device-Bin8Gna7.js";
import { preventPinchZoom as a } from "./prevent-pinch-zoom-CwVKgszi.js";
import { t as o } from "./preload-helper-DYl5dUZ5.js";
(async () => {
  (function() {
    let e2 = document.createElement(`link`).relList;
    if (e2 && e2.supports && e2.supports(`modulepreload`)) return;
    for (let e3 of document.querySelectorAll(`link[rel="modulepreload"]`)) n2(e3);
    new MutationObserver((e3) => {
      for (let t3 of e3) if (t3.type === `childList`) for (let e4 of t3.addedNodes) e4.tagName === `LINK` && e4.rel === `modulepreload` && n2(e4);
    }).observe(document, {
      childList: true,
      subtree: true
    });
    function t2(e3) {
      let t3 = {};
      return e3.integrity && (t3.integrity = e3.integrity), e3.referrerPolicy && (t3.referrerPolicy = e3.referrerPolicy), e3.crossOrigin === `use-credentials` ? t3.credentials = `include` : e3.crossOrigin === `anonymous` ? t3.credentials = `omit` : t3.credentials = `same-origin`, t3;
    }
    function n2(e3) {
      if (e3.ep) return;
      e3.ep = true;
      let n3 = t2(e3);
      fetch(e3.href, n3);
    }
  })();
  var s = `christen-wishlist`, c = `christen-wishlist-handles`, l = () => ({
    ids: e.$persist([]).as(s),
    handles: e.$persist({}).as(c),
    get count() {
      return this.ids.length;
    },
    get isEmpty() {
      return this.ids.length === 0;
    },
    contains(e2) {
      return this.ids.includes(String(e2));
    },
    cacheHandle(e2, t2) {
      if (!t2) return;
      let n2 = String(e2);
      this.handles[n2] !== t2 && (this.handles[n2] = t2);
    },
    add(e2, t2) {
      let n2 = String(e2);
      t2 && this.cacheHandle(n2, t2), !this.ids.includes(n2) && this.ids.push(n2);
    },
    remove(e2) {
      let t2 = String(e2), n2 = this.ids.indexOf(t2);
      n2 !== -1 && (this.ids.splice(n2, 1), delete this.handles[t2]);
    },
    toggle(e2, t2) {
      this.contains(e2) ? this.remove(e2) : this.add(e2, t2);
    },
    clear() {
      this.ids.splice(0, this.ids.length);
      for (let e2 of Object.keys(this.handles)) delete this.handles[e2];
    }
  }), u = {
    app: {
      hasOverlay: false,
      footerVisible: false,
      previousUrl: null
    },
    device: {
      isMobile: n(),
      isDesktop: t(),
      isTouch: r()
    },
    product: {
      zoom: false,
      details: false,
      recommendationsVisible: false,
      toggleZoom() {
        this.zoom = !this.zoom;
      },
      toggleDetails() {
        this.details = !this.details;
      }
    },
    menu: {
      isOpen: false
    },
    wishlist: void 0,
    collection: {
      filters: false,
      gridSize: n() ? `small` : `large`,
      toggleGridSize() {
        this.gridSize = this.gridSize === `small` ? `large` : `small`, window.scrollTo({
          top: 0,
          behavior: `instant`
        });
      }
    }
  }, d = {
    async initAlpine() {
      let [t2, n2, r2, i2, a2, s2, c2, d2, f, p, m, h, g, _, v, y, b, x, S, C, w, T] = await Promise.all([
        o(() => import("./module.esm-b3JG62wE.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), [], import.meta.url),
        o(() => import("./module.esm-C72IOvqj.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), [], import.meta.url),
        o(() => import("./module.esm-CY7aQNYx.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), [], import.meta.url),
        o(() => import("./module.esm-DqLKWW9k.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), [], import.meta.url),
        o(() => import("./module.esm-CDoFkgef.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), [], import.meta.url),
        o(() => import("./module.esm-C1BZ0D29.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), [], import.meta.url),
        o(() => import("./alpine-swap-lYM3j0MN.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([0,1]), import.meta.url),
        o(() => import("./alpine-sync-params-DW0ssYDN.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), [], import.meta.url),
        o(() => import("./alpine-pinch-ClvZfBpq.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), [], import.meta.url),
        o(() => import("./accordion-I9q_btvo.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([2,3,4]), import.meta.url),
        o(() => import("./footer-CjVLgRO4.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([5,4]), import.meta.url),
        o(() => import("./header-Bgn9bTmJ.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([6,4]), import.meta.url),
        o(() => import("./modal-ILPGkwVI.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([7,8,4]), import.meta.url),
        o(() => import("./modal-toggle-CuCS-vJA.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([9,4]), import.meta.url),
        o(() => import("./navigation-DHul_NCp.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([10,4]), import.meta.url),
        o(() => import("./video-player-CdWLIGVS.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([11,3,12,4]), import.meta.url),
        o(() => import("./infinite-scroll-Ct8c6qFA.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([13,1,4]), import.meta.url),
        o(() => import("./product-info-D6pZBQ78.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([14,4]), import.meta.url),
        o(() => import("./product-slider-ZyUCnnrm.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([15,16,4,17,18]), import.meta.url),
        o(() => import("./product-zoom-D6m7hYLY.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([19,16,8,4,17,18]), import.meta.url),
        o(() => import("./wishlist-DJSYajB3.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([20,4]), import.meta.url),
        o(() => import("./wishlist-grid-Bc-56yag.js").then(async (m2) => {
          await m2.__tla;
          return m2;
        }), __vite__mapDeps([21,3,4]), import.meta.url)
      ]);
      e.plugin(t2.default), e.plugin(n2.default), e.plugin(r2.default), e.plugin(i2.default), e.plugin(a2.default), e.plugin(s2.default), e.plugin(c2.default), e.plugin(d2.default), e.plugin(f.default), u.wishlist = l();
      for (let [t3, n3] of Object.entries(u)) e.store(t3, n3);
      e.data(`accordion`, p.default), e.data(`footer`, m.default), e.data(`header`, h.default), e.data(`modal`, g.default), e.data(`modalToggle`, _.default), e.data(`navigation`, v.default), e.data(`videoPlayer`, y.default), e.data(`infiniteScroll`, b.default), e.data(`productInfo`, x.default), e.data(`productSlider`, S.default), e.data(`productZoom`, C.default), e.data(`wishlistButton`, w.default), e.data(`wishlistGrid`, T.default), e.start(), document.body.removeAttribute(`x-cloak`);
    },
    async initWebComponents() {
      await Promise.all([
        o(() => import("./product-recommendations-J7UCm1N-.js").then(async (m) => {
          await m.__tla;
          return m;
        }), [], import.meta.url)
      ]);
    },
    initEventListeners() {
      a(), window.addEventListener(`app:loading`, (e2) => {
        document.body.classList.toggle(`is-loading`, e2.detail);
      }), i.addEventListener(`change`, () => {
        e.store(`device`).isMobile = n(), e.store(`device`).isDesktop = t();
      }), window.addEventListener(`keydown`, (t2) => {
        t2.key === `Escape` && (e.store(`product`).zoom = false, e.store(`product`).details = false);
      });
    },
    async init() {
      await Promise.all([
        this.initAlpine(),
        this.initWebComponents()
      ]), this.initEventListeners(), document.documentElement.classList.add(`loaded`);
    }
  };
  document.readyState === `loading` ? document.addEventListener(`DOMContentLoaded`, () => d.init()) : d.init();
})();
